import { gql } from '@apollo/client';

import { graphql } from '../../../gql';

export const QRY_GET_USER = gql`
  query GetUser {
    me {
      displayName
      givenName
      surname
      jobTitle
      businessPhones
      mobilePhone
      officeLocation
      userPrincipalName
      images {
        large
        medium
        small
      }
      id
      mail
      preferredLanguage
    }
  }
`;

export const SEARCH_USERS = gql`
  query SearchUser($searchString: String!, $limit: Int = 5) {
    mlfsl_personnel(
      where: { NamePreferredDisplay: { _like: $searchString }, ActiveDirectoryDisabledIndicator: { _eq: "N" } }
      limit: $limit
    ) {
      NamePreferredDisplay
      Email
      ActiveDirectoryLogin
      BusinessPrimaryOfficePhoneNumberFull
      TitleFullyQualified
      BusinessPrimaryOfficeAddress1
      BusinessPrimaryOffice
      PrimaryPracticeGroup {
        PracticeGroupName
      }
    }
  }
`;

export const GET_FILTERED_CLIENT_RECORDS = graphql(`
  query GetFilteredClientRecords(
    $limit: Int = 50
    $offset: Int = 0
    $order_by: [mlfsl_client_order_by!] = { ClientName1: asc }
    $where: mlfsl_client_bool_exp
  ) {
    mlfsl_client(limit: $limit, order_by: $order_by, offset: $offset, where: $where) {
      ClientName1
      ClientNumber
      ResponsibleAttorney {
        ActiveDirectoryLogin
        NamePreferredFull
        Email
        TitleFullyQualified
        PrimaryPracticeGroup {
          SubSubPracticeGroupName
        }
        BusinessPrimaryOfficePhoneNumberFull
        BusinessPrimaryOffice
      }
      DateClientClosed
      DateClientOpen
      cmap_clm_engagement_record {
        id
        created_at
        created_by_user {
          ActiveDirectoryLogin
          NamePreferredFull
          Email
          TitleFullyQualified
          PrimaryPracticeGroup {
            PracticeGroupName
          }
          BusinessPrimaryOfficePhoneNumberFull
          BusinessPrimaryOffice
        }
        type
        updated_at
        updated_by_user {
          ActiveDirectoryLogin
          NamePreferredFull
          Email
          TitleFullyQualified
          PrimaryPracticeGroup {
            PracticeGroupName
          }
          BusinessPrimaryOfficePhoneNumberFull
          BusinessPrimaryOffice
        }
        engagement_client_comments {
          id
          comments
          created_by_user {
            ActiveDirectoryLogin
            NamePreferredFull
            Email
            TitleFullyQualified
            PrimaryPracticeGroup {
              PracticeGroupName
            }
            BusinessPrimaryOfficePhoneNumberFull
            BusinessPrimaryOffice
          }
          updated_at
          updated_by_user {
            ActiveDirectoryLogin
            NamePreferredFull
            Email
            TitleFullyQualified
            PrimaryPracticeGroup {
              PracticeGroupName
            }
          }
        }
        engagement_imanage_documents {
          id
          doc_id
          name
          updated_at
          updated_by_user {
            ActiveDirectoryLogin
            NamePreferredFull
            Email
            TitleFullyQualified
            PrimaryPracticeGroup {
              PracticeGroupName
            }
          }
        }
      }
    }
  }
`);

export const GET_CLIENT_RECORDS_LIST = graphql(`
  query GetClientRecordsList($limit: Int = 10000, $where: mlfsl_client_bool_exp) {
    mlfsl_client(limit: $limit, where: $where, order_by: { ClientNumber: asc }) {
      ClientName1
      ClientNumber
      DateClientClosed
      DateClientOpen
      ResponsibleAttorney {
        NamePreferredFull
        PrimaryPracticeGroup {
          SubSubPracticeGroupName
        }
      }
    }
  }
`);

export const GET_RELATED_CLIENTS_LIST = graphql(`
  query GetRelatedClientsList($limit: Int = 10000, $where: mlfsl_related_client_bool_exp) {
    mlfsl_related_client(limit: $limit, where: $where, order_by: { RelatedClientName: asc }) {
      RelatedClientName
      RelatedClientNumber
      Clients {
        ClientName1
        ClientNumber
      }
    }
  }
`);

export const GET_RELATED_CLIENTS_WITH_DOCUMENT_COUNTS = gql`
  query GetRelatedClientsWithDocumentCounts($limit: Int = 1, $where: mlfsl_related_client_bool_exp) {
    mlfsl_related_client(limit: $limit, where: $where) {
      RelatedClientName
      RelatedClientNumber
      Clients {
        ClientName1
        ClientNumber
        ResponsibleAttorney {
          NamePreferredFull
          PrimaryPracticeGroup {
            SubSubPracticeGroupName
          }
        }
        DateClientOpen
        DateClientClosed
        cmap_clm_engagement_record {
          id
          engagement_imanage_documents_aggregate {
            aggregate {
              count
            }
          }
        }
      }
    }
  }
`;

export const GET_RELATED_CLIENTS_COUNT = gql`
  query GetRelatedClientsCount {
    mlfsl_client_aggregate(where: { RelatedClientNumber: { _is_null: false } }) {
      aggregate {
        count(column: RelatedClientNumber, distinct: true)
      }
    }
  }
`;

export const GET_ENGAGEMENT_RECORDS_LIST = graphql(`
  query GetEngagementRecordsList($limit: Int = 10000, $where: clm_engagement_records_bool_exp) {
    clm_engagement_records(limit: $limit, where: $where, order_by: { id: asc }) {
      id
      client_number
      created_at
      updated_at
      engagement_imanage_documents(limit: 1) {
        doc_id
      }
    }
  }
`);

export const GET_PAGINATED_DOCUMENTS = graphql(`
  query GetPaginatedDocuments(
    $clientNumber: String!
    $limit: Int = 10
    $offset: Int = 0
    $where: clm_engagement_imanage_documents_bool_exp
  ) {
    mlfsl_client(where: { ClientNumber: { _eq: $clientNumber } }, limit: 1) {
      cmap_clm_engagement_record {
        engagement_imanage_documents_aggregate(where: $where) {
          aggregate {
            count
          }
        }
        engagement_imanage_documents(limit: $limit, offset: $offset, where: $where) {
          id
          doc_id
          name
        }
      }
    }
  }
`);

export const GET_WAIVER_LIST = graphql(`
  query GetWaiverRecordsList($limit: Int = 20000, $where: clm_waiver_records_bool_exp) {
    clm_waiver_records(limit: $limit, where: $where, order_by: { id: asc }) {
      id
      matter_number
      client_number
      adverse_client_name
      adverse_contact_signer
      adverse_letter_date
      adverse_mlb_attorney_on_letter_name
      client_contact
      client_letter_date
      mlb_attorney_on_client_letter_name
      multiple_waivers
      mlfsl_client {
        ClientName1
      }
    }
  }
`);

export const GET_PAGINATED_WAIVER_DOCUMENTS = graphql(`
  query GetPaginatedWaiverDocuments(
    $waiverRecordId: uuid!
    $limit: Int = 10
    $offset: Int = 0
    $where: clm_waiver_imanage_documents_bool_exp
  ) {
    clm_waiver_records(where: { id: { _eq: $waiverRecordId } }, limit: 1) {
      waiver_imanage_documents_aggregate(where: $where) {
        aggregate {
          count
        }
      }
      waiver_imanage_documents(limit: $limit, offset: $offset, where: $where) {
        id
        doc_id
        name
        created_at
        updated_at
        waiver_records_id
      }
    }
  }
`);

export const GET_FILTERED_WAIVER_RECORDS = graphql(`
  query GetWaiverRecord($waiver_id: uuid!) {
    clm_waiver_records_by_pk(id: $waiver_id) {
      id
      matter_number
      client_number
      client_contact
      client_letter_date
      mlb_attorney_on_client_letter_name
      adverse_mlb_attorney_on_letter_name
      adverse_client_name
      adverse_contact_signer
      adverse_letter_date
      multiple_waivers
      comments
      created_at
      created_by_user {
        ActiveDirectoryLogin
        NamePreferredFull
        Email
      }
      updated_at
      updated_by_user {
        ActiveDirectoryLogin
        NamePreferredFull
        Email
      }
      mlfsl_client {
        ClientName1
      }
    }
  }
`);
